import React, { memo } from "react";
import detailsbox from "../../../assets/images/detailsbox.png";
import {
  BookingStatusWrap,
  BookingStatusBar,
  LiMain,
  ItemText,
} from "./styles/BookingStatusStyle";
import { formatTime, formatDate } from "../../../helpers/formatTime";

const BookingStatus = ({ OrderData = [] }) => {
  const { order_statuses } = OrderData;

  const GetPendingStatus =
    order_statuses?.filter((status) => status?.status === "pending") ?? [];
  const GetCancelledStatus =
    order_statuses?.filter((status) => status?.status === "cancelled") ?? [];
  const Getdriver_assignedStatus =
    order_statuses?.filter((status) => status?.status === "driver_assigned") ??
    [];
  const GetDriver_arrivedStatus =
    order_statuses?.filter((status) => status?.status === "driver_arrived") ??
    [];
  const GetOrder_pickedStatus =
    order_statuses?.filter((status) => status?.status === "order_picked") ?? [];
  const GetDriverDepartedStatus =
    order_statuses?.filter((status) => status?.status === "driver_departed") ??
    [];
  const GetDriverReachedDropOffStatus =
    order_statuses?.filter(
      (status) => status?.status === "driver_reached_at_drop_off"
    ) ?? [];
  const GetOrderDelivered =
    order_statuses?.filter((status) => status?.status === "order_delivered") ??
    [];
  console.log(
    "🚀 ~ file: BookingStatus.js:34 ~ BookingStatus ~ GetOrderDelivered:",
    GetOrderDelivered
  );
  const GetApprovedStatus =
    order_statuses?.filter((status) => status?.status === "approved") ?? [];

  return (
    <BookingStatusWrap>
      <BookingStatusBar>
        {order_statuses && (
          <>
            {GetPendingStatus?.length > 0 && (
              <>
                <LiMain className="requestSection">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Request</h6>
                      <p>New Delivery request has been made.</p>
                      <span>
                        {formatDate(GetPendingStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetPendingStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetCancelledStatus?.length > 0 && (
              <>
                <LiMain className="cancelledSection">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Cancelled</h6>
                      <p>New Delivery request has been cancelled.</p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {Getdriver_assignedStatus?.length > 0 && (
              <>
                <LiMain className="DriverSection">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Driver assigned</h6>
                      <p>Driver has been assigned to you.</p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetDriver_arrivedStatus?.length > 0 && (
              <>
                <LiMain className="DriverArrived">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Driver Arrived</h6>
                      <p>
                        Driver have arrived at the pick-up location and waiting
                        for the customer.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetOrder_pickedStatus?.length > 0 && (
              <>
                <LiMain className="PickedOrder">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Picked Order</h6>
                      <p>
                        Driver have picked up your order from the pick-up
                        location.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetDriverDepartedStatus?.length > 0 && (
              <>
                <LiMain className="DriverDeparted">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Driver Departed</h6>
                      <p>
                        Driver is en-route from the pick-up location to drop-off
                        location.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetDriverReachedDropOffStatus?.length > 0 && (
              <>
                <LiMain className="Dropoff">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Driver Reached at Drop-off</h6>
                      <p>
                        Driver have reached at the drop-off location and waiting
                        for the customer.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {GetOrderDelivered?.length > 0 && (
              <>
                <LiMain className="OrderDelivered">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Order Delivered</h6>
                      <p>
                        Driver delivered the order successfully at the drop-off
                        location.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )}
            {/* {GetApprovedStatus?.length > 0 && (
              <>
                <LiMain className="OrderDelivered">
                  <div className="itemMain">
                    <div className="itemimg">
                      <img src={detailsbox} alt="detailsbox" />
                    </div>
                    <ItemText>
                      <h6>Order Delivered</h6>
                      <p>
                        Driver delivered the order successfully at the drop-off
                        location.
                      </p>
                      <span>
                        {formatDate(GetCancelledStatus[0]?.timestamp)} at{" "}
                        {formatTime(GetCancelledStatus[0]?.timestamp)}
                      </span>
                    </ItemText>
                  </div>
                </LiMain>
              </>
            )} */}
          </>
        )}
      </BookingStatusBar>
    </BookingStatusWrap>
  );
};

export default memo(BookingStatus);
